module.exports = __webpack_public_path__ + "static/media/sparkleOutline.da1fbce2.png";